import { useEffect, useState } from "react";
import "./App.css";
import Calculator from "./components/Calculator";
import Navbar from "./components/Navbar";

const App = () => {
  const [value, setValue] = useState<string>("0");
  const [arr, setArr] = useState<string[]>([]);

  useEffect(() => {
    localStorage.setItem("history", JSON.stringify([]));
  }, []);

  return (
    <div className="parent">
      <Navbar value={value} arr={arr} setArr={setArr} />
      <Calculator value={value} setValue={setValue} setArr={setArr} />
    </div>
  );
};

export default App;
